module.exports = __webpack_public_path__ + "img/ic-loading-default.5cfc9572.svg";